import { render, staticRenderFns } from "./ObjectRender.vue?vue&type=template&id=e68c0f64&scoped=true&"
import script from "./ObjectRender.vue?vue&type=script&lang=ts&"
export * from "./ObjectRender.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectRender.vue?vue&type=style&index=0&id=e68c0f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68c0f64",
  null
  
)

export default component.exports